import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface PageHeaderIdentity {
    name: string;
    rfc?: string;
}

export interface PageHeaderBreadcrumb {
    id: 'kpi' | 'contractor' | 'provider' | 'contract' | 'period';
    label: string;
    subtitle?: string;
    compactLabel?: string;
    link?: string;
    details?: ReadonlyArray<{label: string; value: string}>;
}

export interface PageHeaderContext {
    backLink: string;
    backLabel: string;
    contractor?: PageHeaderIdentity;
    provider?: PageHeaderIdentity;
    breadcrumbs?: ReadonlyArray<PageHeaderBreadcrumb>;
}

@Injectable({ providedIn: 'root' })
export class PageHeaderContextService {
    private readonly contextSubject = new BehaviorSubject<PageHeaderContext | null>(null);
    private activeOwner: symbol | null = null;

    readonly context$: Observable<PageHeaderContext | null> = this.contextSubject.asObservable();

    claim(): symbol {
        const owner = Symbol('page-header-owner');
        this.activeOwner = owner;
        this.contextSubject.next(null);
        return owner;
    }

    update(owner: symbol, context: PageHeaderContext | null): void {
        if (owner === this.activeOwner) {
            this.contextSubject.next(context);
        }
    }

    release(owner: symbol): void {
        if (owner === this.activeOwner) {
            this.activeOwner = null;
            this.contextSubject.next(null);
        }
    }
}
